'use client';

import { useEffect, useMemo, useRef, useState } from 'react';
import { useRouter } from 'next/navigation';
import styles from '@/styles/dashboard.module.css';
import { useAuth } from '@/lib/context/AuthContext';
import { ClockIcon } from './Icons';
import { ProfileDropdown } from './ProfileDropdown';
import { DashboardSettingsModal } from './DashboardSettingsModal';

export function Navbar() {
  const router = useRouter();
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [avatarFailed, setAvatarFailed] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  // FIX: Avatar URL bisa datang dari beberapa field response API
  const avatarUrl = (user as any)?.avatar || (user as any)?.photo_url || (user as any)?.profile_picture || (user as any)?.image;

  const initials = useMemo(() => {
    if (!user?.name) return 'GU';
    return user.name
      .split(' ')
      .map((part) => part[0])
      .join('')
      .slice(0, 2)
      .toUpperCase();
  }, [user?.name]);

  useEffect(() => {
    if (!open) return;

    const onPointerDown = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', onPointerDown);
    return () => document.removeEventListener('mousedown', onPointerDown);
  }, [open]);

  useEffect(() => {
    setAvatarFailed(false);
  }, [avatarUrl]);

  return (
    <nav className={styles.navbar}>
      <div className={styles.navbarLeft}>
        <button type="button" className={styles.navIconBtn} aria-label="Back" onClick={() => router.back()}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="m15 18-6-6 6-6" />
          </svg>
        </button>
        <button type="button" className={styles.navIconBtn} aria-label="Forward" onClick={() => router.forward()}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="m9 18 6-6-6-6" />
          </svg>
        </button>
        <button type="button" className={styles.navIconBtn} aria-label="History">
          <ClockIcon size={16} color="currentColor" />
        </button>
      </div>

        <div className={styles.navbarCenter} />

      <div className={styles.navbarRight} ref={containerRef}>
        <button
          type="button"
          className={styles.avatarButton}
          aria-label="Profile"
          onClick={() => setOpen((value) => !value)}
          style={avatarUrl && !avatarFailed ? { padding: 0, overflow: 'hidden', background: 'transparent', display: 'grid', placeItems: 'center' } : {}}
        >
          {avatarUrl && !avatarFailed ? (
            <img
              src={avatarUrl}
              alt={user?.name || 'Profile'}
              // FIX: Foto profil harus menggantikan badge dan tetap bulat, bukan gepeng/lonjong
              style={{ width: 36, height: 36, aspectRatio: '1 / 1', borderRadius: '50%', objectFit: 'cover', display: 'block', flexShrink: 0 }}
              onError={() => setAvatarFailed(true)}
              onLoad={() => setAvatarFailed(false)}
            />
          ) : (
            initials
          )}
        </button>
        {open ? <ProfileDropdown onSettings={() => { setOpen(false); setShowSettings(true); }} /> : null}
      </div>
      {showSettings ? <DashboardSettingsModal onClose={() => setShowSettings(false)} /> : null}
    </nav>
  );
}
